import { render, staticRenderFns } from "./MyEventMenu.vue?vue&type=template&id=e1897618&scoped=true&"
import script from "./MyEventMenu.vue?vue&type=script&lang=js&"
export * from "./MyEventMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1897618",
  null
  
)

export default component.exports